import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CSpinner } from '@coreui/react-pro'
import { getProgressNoteImage } from '../../../helper/backendHelper'
import PanelProgressNote from './SideNoteComponents/PanelProgressNote'
import PanelCompletedNoteButtons from './SideNoteComponents/PanelCompletedNoteButtons'

export default function NotePanel({ saveNoteRef }) {
  const panelEncounter = useSelector((state) => state.sidePanel.panelEncounter)
  const panelEncounterId = useSelector((state) => state.sidePanel.panelEncounter?._id)
  const sharedServiceProviderId = useSelector(
    (state) => state.sidePanel.panelEncounter?.incident_to_provider_id,
  )
  const isLastEncounter = useSelector((state) => state.sidePanel.isLastEncounter)
  const panelChart = useSelector((state) => state.sidePanel.panelChart)
  const chartSignedOn = useSelector((state) => state.sidePanel.panelChart?.signed_on)
  const chartSignedUserId = useSelector((state) => state.sidePanel.panelChart?.signed_user_id)
  const chartCosignedOn = useSelector((state) => state.sidePanel.panelChart?.cosigned_on)

  const providerId = useSelector((state) => state?.user?.provider?._id)

  const noteClosed = sharedServiceProviderId
    ? chartCosignedOn || (chartSignedOn && providerId === chartSignedUserId)
    : chartSignedOn

  const [noteImg, setNoteImg] = useState(null)

  useEffect(() => {
    if (panelEncounterId && !isLastEncounter && noteClosed) {
      getProgressNoteImage(panelEncounterId, 'notepanel').then((res) => {
        if (res?.status === 'success') {
          setNoteImg(res?.data)
        } else {
          setNoteImg(null)
        }
      })
    }
  }, [panelEncounterId, isLastEncounter, noteClosed])

  // EVIL HACK so we can save on closing panel
  if (!(!noteClosed && panelChart)) {
    saveNoteRef.current = null
  }

  return (
    <div id={'Side-Note-Panel'} className={panelChart ? '' : 'hide'}>
      <div id={'NotePanel'}>
        {!panelEncounter && (
          <div className={'side-panel-spinner d-flex justify-content-center'}>
            <CSpinner />
          </div>
        )}
        {noteClosed && (
          <div className={'display-box'}>
            <div className="note-image-holder">
              <img src={noteImg} alt="Note Img" style={{ width: '100%' }} />
            </div>

            <PanelCompletedNoteButtons />
          </div>
        )}

        {!noteClosed && panelChart && (
          <div className={'display-box'}>
            <PanelProgressNote saveNoteRef={saveNoteRef} />
          </div>
        )}
      </div>
    </div>
  )
}
